var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiPickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z",
    fill: "#1B1A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8289 14.828C14.4634 15.1924 14.0317 15.4836 13.5569 15.686C12.7022 16.0469 11.7487 16.0995 10.8595 15.835C9.97022 15.5705 9.20049 15.0053 8.68193 14.236L7.02393 15.355C7.45636 15.9932 8.00652 16.543 8.64493 16.975C9.29458 17.4143 10.0245 17.7212 10.7929 17.878C11.5897 18.0405 12.4111 18.0405 13.2079 17.878C13.9763 17.721 14.7062 17.4141 15.3559 16.975C15.6689 16.763 15.9679 16.517 16.2419 16.244C16.5139 15.973 16.7619 15.673 16.9759 15.355L15.3179 14.236C15.1742 14.4485 15.0105 14.6468 14.8289 14.828Z",
    fill: "#1B1A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.493 11.986C16.3176 11.986 16.986 11.3176 16.986 10.493C16.986 9.66844 16.3176 9 15.493 9C14.6684 9 14 9.66844 14 10.493C14 11.3176 14.6684 11.986 15.493 11.986Z",
    fill: "#1B1A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12Z",
    fill: "#1B1A57"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiPickerIcon);
export default __webpack_public_path__ + "static/media/emojiPickerIcon.117783fa.svg";
export { ForwardRef as ReactComponent };